import { Injectable, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ErrorSuccessService {
  isErrorObject: EventEmitter<unknown> = new EventEmitter<unknown>();
  isSuccessObject: EventEmitter<unknown> = new EventEmitter<unknown>();

  constructor() {}

  setError(data: unknown) {
    this.isErrorObject.emit(data);
  }

  setSuccess(data: unknown) {
    this.isSuccessObject.emit(data);
  }
}
